export const CHART_CONFIG = {
  HEIGHT: 400,
  WIDTH: 500,
  CHART_HEIGHT: 348,
  MARGIN: { top: 20, right: 30, left: 20, bottom: 5 },
  BORDER_RADIUS: 8,
} as const;
